<template>
  <div v-if="answer">
    <p
      class="text-base leading-6 text-darkBlue  tracking-wide uppercase font-open-sans text-lg tracking-tight border-b border-vectric font-bold pb-2"
    >
      {{ question }}
    </p>
    <vue-markdown
      :source="answer"
      :anchorAttributes="{ target: '_blank' }"
      class="text-gray-700 text-base prose pt-2"
    ></vue-markdown>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";
export default {
  name: "QuestionAnswer",
  components: {
    VueMarkdown
  },
  props: {
    question: {
      type: String,
      required: true
    },
    answer: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped></style>
